module.exports = __webpack_public_path__ + "img/asem-white.6125c2a2.png";